import React from 'react';

import { Box, Divider, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormCheck,
    ReactHookFormIntlNumberInput,
    ReactHookFormToggleButtonGroupV2,
} from 'common/components/form';

import {
    getAppendText,
    getPreAppendText,
    handleOnBlurField,
} from '../../helpers';

const DownPaymentFields = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters_hitch';

    const parametersHitch = useWatch({ control, name });

    return (
        <Box>
            <Typography fontWeight={600} variant="body2">
                {t('Minimum down payment')}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Grid container>
                <ReactHookFormCheck
                    control={control}
                    disabled={disabled}
                    name={`${name}.isChecked`}
                />

                <Grid size="grow">
                    <Grid container>
                        <Grid size="grow">
                            <ReactHookFormIntlNumberInput
                                append={getAppendText('MXN', parametersHitch)}
                                control={control}
                                disabled={
                                    !parametersHitch ||
                                    !parametersHitch.isChecked ||
                                    disabled
                                }
                                fullWidth
                                label={t('Minimum down payment')}
                                name={`${name}.value`}
                                onBlur={({ value }) =>
                                    handleOnBlurField({
                                        name: `${name}.value`,
                                        value,
                                        setValue,
                                    })
                                }
                                prepend={getPreAppendText('$', parametersHitch)}
                            />
                        </Grid>

                        <Grid size="auto">
                            <ReactHookFormToggleButtonGroupV2
                                control={control}
                                disabled={
                                    !parametersHitch ||
                                    !parametersHitch.isChecked ||
                                    disabled
                                }
                                fullWidth
                                name={`${name}.unit`}
                                options={[
                                    { label: '%', value: 0 },
                                    { label: '$', value: 1 },
                                ]}
                                sx={{ minWidth: '120px' }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

DownPaymentFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default DownPaymentFields;
